module.exports = new __parcel__URL__("marker-icon.3f7d3721.png").toString();